import React, { useState } from "react";
import "./homePage";

const GetInTouchButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    emailid: "",
    phonenumber: "",
    message: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const token = sessionStorage.getItem("jwtToken");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/user/enquirySave`, {
        method: "POST",
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowSuccess(true);   // show success popup
        setIsOpen(false);       // close form modal
        setFormData({ fullname: "", emailid: "", phonenumber: "", message: "" });
      } else {
        setShowError(true);     // show error popup
        setIsOpen(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setShowError(true);       // show error popup
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Open Button */}
      <button onClick={() => setIsOpen(true)} className="get-in-touch-btn">
        Get in Touch
      </button>

      {/* Popup Modal */}
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-box">
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="modal-close-btn"
            >
              ×
            </button>

            <h3 className="modal-title">Get in Touch</h3>

            <form onSubmit={handleSubmit} className="modal-form">
              <label>
                Name
                <input
                  type="text"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                Email
                <input
                  type="email"
                  name="emailid"
                  value={formData.emailid}
                  onChange={handleChange}
                  required
                />
              </label>
              <label>
                Phone Number
                <input
                  type="text"
                  name="phonenumber"
                  value={formData.phonenumber}
                  onChange={handleChange}
                />
              </label>
              <label>
                Description
                <textarea
                  name="message"
                  rows="2"
                  value={formData.message}
                  onChange={handleChange}
                />
              </label>
              <div className="mt-auto text-left">
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccess && (
        <div className="modal-overlay">
          <div className="modal-box text-center">
            <h3 className="text-green-600 font-bold text-xl mb-4">✅ Thank You!</h3>
            <p>Your enquiry has been submitted successfully.</p>
            <button
              onClick={() => setShowSuccess(false)}
              className="submit-btn mt-4"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {showError && (
        <div className="modal-overlay">
          <div className="modal-box text-center">
            <h3 className="text-red-600 font-bold text-xl mb-4">❌ Oops!</h3>
            <p>Something went wrong. Please try again later.</p>
            <button
              onClick={() => setShowError(false)}
              className="submit-btn mt-4"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default GetInTouchButton;
